<template>
  <div class="text-gray-700">
    <label class="block mb-1 required text-gray-smoke font-medium text-sm md:text-lg mb-2">Category </label>
    <select
      class="form-select text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
      :class="{ 'border-red-700': $v.categoryId.$error }"
      v-model="$v.categoryId.$model"
      @change="categoryChange"
    >
      <option value="">Choose your categories</option>
      <option :value="c.id" v-for="c in categoriesList" :key="c.id">
        {{ c.name }}
      </option>
    </select>
    <div class="mt-2 flex flex-wrap">
      <span
        class="px-4 mr-2 mb-2 rounded-lg py-1 text-white focus:outline-none"
        :class="[selectedColor ? selectedColor : 'bg-green-light']"
        v-for="c in categoriesData"
        :key="c.id"
      >
        <span class="text-sm">{{ c.text }}</span>
        <button type="button" class="ml-2" @click="categoryRemove(c.id)">
          X
        </button>
      </span>
    </div>
    <div v-if="!$v.categoriesData.maxLength">
      <span class="text-xs text-red-700">
        Maximum of 4 categories allowed
      </span>
    </div>
    <div>
      <span class="text-xs text-red-700" v-if="!$v.categoriesData.required">
        Category is required
      </span>
    </div>
  </div>
</template>

<script>
import { maxLength, required } from "vuelidate/lib/validators";

export default {
  name: "CategoryInput",
  props: {
    categoriesList: {
      type: [Array, Object],
    },
    categoriesData: {
      type: Array,
      default: [],
    },
    category_id: {
      type: String,
    },
    selectedColor: {
      type: String,
      required: false,
    }
  },
  validations: {
    categoriesData: {
      required,
      maxLength: maxLength(4),
    },
    category_id: {
      required,
    },
    categoryId: {
      required,
    },
  },
  data() {
    return {};
  },
  computed: {
    categoryId: {
      // getter
      get: function () {
        return this.category_id;
      },
      // setter
      set: function () {},
    },
  },
  methods: {
    categoryChange(event) {
      this.$emit("CategoriesChange", event);
    },
    categoryRemove(id) {
      this.$emit("CategoriesRemove", id);
    },
  },
};
</script>